import { jsx as e, jsxs as s } from "react/jsx-runtime";
import { twMerge as i } from "tailwind-merge";
const l = (r) => {
  const { fill: a = "md", orientation: t = "horizontal", className: n, ...c } = r;
  return /* @__PURE__ */ e(
    "div",
    {
      className: i(
        "animate-pulse rounded bg-gray-200",
        t === "horizontal" ? "h-2" : "w-2",
        m(t)(a),
        n
      ),
      tabIndex: -1,
      "aria-hidden": !0,
      ...c
    }
  );
}, o = () => /* @__PURE__ */ s("div", { className: "flex flex-col gap-4", children: [
  /* @__PURE__ */ e(l, { fill: "sm" }),
  /* @__PURE__ */ e(l, { fill: "md" }),
  /* @__PURE__ */ e(l, { fill: "lg" }),
  /* @__PURE__ */ e(l, { fill: "xl" }),
  /* @__PURE__ */ e(l, { fill: "sm" }),
  /* @__PURE__ */ e(l, { fill: "md" })
] }), u = () => /* @__PURE__ */ s("div", { className: "flex flex-col gap-4", children: [
  /* @__PURE__ */ e(l, { className: "h-5" }),
  /* @__PURE__ */ e(l, { fill: "sm", className: "h-3" })
] }), m = (r) => r === "horizontal" ? h : f, h = (r) => {
  switch (r) {
    case "xs":
      return "w-1/5";
    case "sm":
      return "w-2/5";
    case "md":
      return "w-3/5";
    case "lg":
      return "w-3/4";
    case "xl":
      return "w-11/12";
    case "full":
      return "w-full";
  }
}, f = (r) => {
  switch (r) {
    case "xs":
      return "h-1/5";
    case "sm":
      return "h-2/5";
    case "md":
      return "h-3/5";
    case "lg":
      return "h-3/4";
    case "xl":
      return "h-4/5";
    case "full":
      return "h-full";
  }
}, x = l, w = u, p = o;
export {
  x as Bar,
  w as BigText,
  p as Paragraph,
  l as SkeletonBar,
  u as SkeletonBigText,
  o as SkeletonParagraph
};
